import { useEffect, useState } from "react";
import { api, formatarErroApi } from "@/api";
import { LayoutAutenticado } from "@/componentes/LayoutAutenticado";
import { toast } from "sonner";

function formatarData(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" });
}

export default function MeusPalpites() {
  const [palpites, setPalpites] = useState([]);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/palpites/meus");
        setPalpites(data);
      } catch (e) {
        toast.error(formatarErroApi(e));
      } finally {
        setCarregando(false);
      }
    })();
  }, []);

  return (
    <LayoutAutenticado>
      <div data-testid="pagina-meus-palpites">
        <div className="mb-8">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-amarelobrasil">Histórico</div>
          <h1 className="font-heading text-4xl font-bold uppercase mt-1">Meus palpites</h1>
        </div>

        {carregando ? (
          <div className="text-white/40">Carregando...</div>
        ) : palpites.length === 0 ? (
          <div className="surface-card rounded-2xl p-10 text-center text-white/50">
            Você ainda não fez nenhum palpite. Vá em <strong>Palpitar</strong> para começar.
          </div>
        ) : (
          <div className="surface-card rounded-2xl overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-white/5">
                <tr className="text-left text-[10px] uppercase tracking-widest text-white/50 font-bold">
                  <th className="px-4 py-3">Rodada</th>
                  <th className="px-4 py-3">Jogo</th>
                  <th className="px-4 py-3">Data</th>
                  <th className="px-4 py-3 text-center">Palpite</th>
                  <th className="px-4 py-3 text-center">Resultado</th>
                  <th className="px-4 py-3 text-right">Pontos</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5">
                {palpites.map((p) => {
                  const j = p.jogo || {};
                  return (
                    <tr key={p.id} className="hover:bg-white/[0.02]" data-testid={`linha-palpite-${p.id}`}>
                      <td className="px-4 py-3 text-white/60">{j.rodada || "—"}</td>
                      <td className="px-4 py-3 font-bold">
                        {(j.selecaoMandante && j.selecaoVisitante) ? `${j.selecaoMandante} × ${j.selecaoVisitante}` : "Jogo"}
                      </td>
                      <td className="px-4 py-3 text-white/60">{formatarData(j.dataHoraJogo)}</td>
                      <td className="px-4 py-3 text-center font-heading font-bold tabular-nums">
                        {p.golsMandantePalpite} × {p.golsVisitantePalpite}
                      </td>
                      <td className="px-4 py-3 text-center font-heading font-bold tabular-nums text-amarelobrasil">
                        {j.resultadoLancado ? `${j.golsMandante} × ${j.golsVisitante}` : "—"}
                      </td>
                      <td className="px-4 py-3 text-right">
                        <span
                          className={
                            p.pontosGerados >= 20
                              ? "font-heading font-black text-verdebrasil text-lg"
                              : p.pontosGerados > 0
                              ? "font-heading font-bold text-amarelobrasil text-lg"
                              : "text-white/40"
                          }
                        >
                          {p.statusPalpite === "ENCERRADO" ? p.pontosGerados : "—"}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </LayoutAutenticado>
  );
}
